import axios from 'axios';
import getHeaders from '../utils/getHeaders';
import { providerListEndpoint } from '../config';
import { logger } from '../logger';

const log = logger();

const getChatToken = async (providerId, professionalId) => {
  try {
    const { data } = await axios.post(
      `${providerListEndpoint}/${providerId}/professionals/${professionalId}/chat/token`,
      null,
      getHeaders(),
    );
    return data?.token ?? null;
  } catch (err) {
    log.error('Error getting chat token', err.response);
    return null;
  }
};

const disconnectChat = () => {
  try {
    document
      .getElementById('amazon-connect-chat-widget-iframe')
      ?.contentWindow?.connect?.ChatSession?.disconnect();
  } catch (err) {
    log.error('Error disconnecting chat', err);
  }
};

const chatService = {
  getChatToken,
  disconnectChat,
};

export default chatService;
